import { SEO } from "custom-types/Directus";

const ProductsCopyBlocks: React.FC<{
  blocks?: SEO["copyBlocks"];
  className?: string;
}> = ({ blocks, className }) =>
  blocks?.length ? (
    <>
      {blocks.map((block) => (
        <section className={className} key={block.title}>
          <h2 className="mb-sm">{block.title}</h2>
          <div
            className="dangerously-set-html"
            dangerouslySetInnerHTML={{ __html: block.text || "" }}
          />
        </section>
      ))}
    </>
  ) : (
    <></>
  );
export default ProductsCopyBlocks;
